import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { KIOSK_PRO_MEDIA, kioskTouchHints } from 'src/components/kiosk-pro/kiosk-pro-shared/kiosk-pro-shared.styles';
import { KioskScrollableModalContainer } from 'src/components/kiosk-pro/kiosk-pro-shared/kiosk-scrollable-modal-container';

type ModalSizeConfig = {
  maxWidth: string;
  maxHeight: string;
  padding: string;
  headingFontSize: string;
  headingWidth: string;
  contentFontSize: string;
  sectionSpacing: string;
  buttonHeight: string;
  buttonGap: string;
};

/** Generates the size-variant styles that change across breakpoints. */
const sizeVariant = ({
  maxWidth,
  maxHeight,
  padding,
  headingFontSize,
  headingWidth,
  contentFontSize,
  sectionSpacing,
  buttonHeight,
  buttonGap,
}: ModalSizeConfig): FlattenSimpleInterpolation => css`
  max-width: ${maxWidth};
  max-height: ${maxHeight};
  padding: ${padding};

  h3 {
    font-size: ${headingFontSize};
    width: ${headingWidth};
    margin-bottom: ${sectionSpacing};
  }

  /* Sibling selector targets CountdownModal's internal DOM which we don't control */
  h3 + div {
    font-size: ${contentFontSize};
    margin: 0 0 ${sectionSpacing};
  }

  button {
    font-size: ${contentFontSize};
    height: ${buttonHeight};
  }

  button:first-of-type {
    margin-bottom: ${buttonGap};
  }
`;

export const EndSessionModalContainer = styled(KioskScrollableModalContainer)`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  justify-content: center;
  border-radius: 20px;

  a,
  button {
    ${kioskTouchHints}
  }

  h3 {
    font-weight: 700;
    line-height: 120%;
  }

  h3 + div {
    max-width: 524px;
    color: ${({ theme }) => theme.colors.grey[50]};
    line-height: 120%;
  }

  button {
    font-weight: 700;
    line-height: 120%;
    max-width: 100%;
  }

  ${sizeVariant({
    maxWidth: '820px',
    maxHeight: '528px',
    padding: '56px 36px',
    headingFontSize: '36px',
    headingWidth: '376px',
    contentFontSize: '24px',
    sectionSpacing: '56px',
    buttonHeight: '68px',
    buttonGap: '24px',
  })}

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    ${sizeVariant({
      maxWidth: '720px',
      maxHeight: '416px',
      padding: '40px 28px',
      headingFontSize: '28px',
      headingWidth: '374px',
      contentFontSize: '20px',
      sectionSpacing: '40px',
      buttonHeight: '60px',
      buttonGap: '20px',
    })}
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    ${sizeVariant({
      maxWidth: '672px',
      maxHeight: '416px',
      padding: '40px 28px',
      headingFontSize: '28px',
      headingWidth: '374px',
      contentFontSize: '20px',
      sectionSpacing: '40px',
      buttonHeight: '60px',
      buttonGap: '20px',
    })}
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly}, ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    ${sizeVariant({
      maxWidth: '680px',
      maxHeight: '341px',
      padding: '36px 24px',
      headingFontSize: '24px',
      headingWidth: '374px',
      contentFontSize: '16px',
      sectionSpacing: '36px',
      buttonHeight: '52px',
      buttonGap: '16px',
    })}
  }
`;
